/**
 * Sorts object keys alphabetically and recursively.
 * @param obj The object to sort it's keys.
 * @returns The whole object with all keys sorted alphabetically.
 */
export const sortObjectKeys = (obj: Record<string, unknown>) => {
  if (obj === null || typeof obj !== 'object') return obj;

  const sortedObj: Record<string, unknown> = {};
  Object.keys(obj)
    .sort()
    .forEach((key) => {
      sortedObj[key] = sortObjectKeys(obj[key] as Record<string, unknown>);
    });

  return sortedObj;
};

const hashFn = async (data: string) => {
  const msgBuffer = new TextEncoder().encode(data);

  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
};

/**
 *
 * Simple hashing function of object
 * @param obj
 * @returns A hex string representing the hashed object
 */
export const hashObject = async (obj: Record<string, unknown>) => {
  const sortedObj = sortObjectKeys(obj);
  const jsonObj = JSON.stringify(sortedObj);

  return await hashFn(jsonObj);
};
